import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./themes";

import ErrorBoundary from "./components/error-boundary/error-boundary.component";
import Spinner from "./components/spinner/spinner.component";
import { GlobalStyle } from "./global.styles";
import WebSocketProvider from "./providers/WebSocketProvider";
import { theme } from "./redux/globals/global.selector";
import { checkUserSession, signOutSuccess } from "./redux/user/user.actions";
import { selectCurrentUser } from "./redux/user/user.selector";

const MainAppSwitcher = lazy(() => import("./MainAppSwitcher"));
const AuthSwitcher = lazy(() => import("./AuthSwitcher"));

const App = ({ theme, checkUserSession, currentUser, signOut }) => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    checkUserSession();
  }, [checkUserSession]);

  React.useEffect(() => {
    if (currentUser?.token) {
      try {
        const payloadBase64 = currentUser.token.split(".")[1];
        if (payloadBase64) {
          const decoded = JSON.parse(atob(payloadBase64));
          // exp is in seconds, Date.now() is in ms
          if (decoded.exp && decoded.exp * 1000 < Date.now()) {
            signOut();
            navigate("/account", { replace: true });
          }
        }
      } catch (e) {
        // Token is invalid/malformed
        signOut();
        navigate("/account", { replace: true });
      }
    }
  }, [location.pathname, currentUser, navigate, signOut]);

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <WebSocketProvider>
        <>
          <GlobalStyle />
          <ErrorBoundary>
            <Suspense fallback={<Spinner />}>
              <Routes>
                <Route path="/account/*" element={<AuthSwitcher />} />
                <Route path="/*" element={<MainAppSwitcher />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </>
      </WebSocketProvider>
    </ThemeProvider>
  );
};

const mapStateToProps = createStructuredSelector({
  theme: theme,
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  checkUserSession: () => dispatch(checkUserSession()),
  signOut: () => dispatch(signOutSuccess()),
});
// export default App;
export default connect(mapStateToProps, mapDispatchToProps)(App);
